import mixins from 'vue-typed-mixins'

import Utilities from '~mixins/utilities'
import { VoucherSale } from '~models/VoucherSale'

export default mixins(Utilities).extend({
  computed: {
    purchase(): VoucherSale {
      return this.$store.getters['sales/purchase']
    },
    currency(): string {
      return this.purchase.voucherDenominationCurrency
    },
  },
})
